import { useState, useEffect } from 'react';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import { EXTERNAL_SERVICES } from '../config/constants';
import './IntellicareWidget.css';

const IntellicareWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    const handleOpen = () => { setIsOpen(true); setIsMinimized(false); };
    window.addEventListener('openIntellicareWidget', handleOpen);
    return () => window.removeEventListener('openIntellicareWidget', handleOpen);
  }, []);

  const openWidget = () => { setIsOpen(true); setIsMinimized(false); };
  const closeWidget = () => { setIsOpen(false); setIsMinimized(false); };
  const minimizeWidget = () => { setIsMinimized(true); };
  const restoreWidget = () => { setIsMinimized(false); };

  return (
    <>
      {!isOpen && (
        <button className="intellicare-fab" onClick={openWidget} aria-label="Open Chat">
          <img src="/mss/Intellicare_Logo_Green_1.png" alt="" className="fab-logo" />
          <span className="fab-text">Chat with AI</span>
          <span className="fab-pulse"></span>
        </button>
      )}
      {isOpen && (
        <div className={`intellicare-widget ${isMinimized ? 'minimized' : ''}`}>
          <div className="widget-header widget-header--slim">
            <div className="widget-controls">
              {isMinimized ? (
                <button onClick={restoreWidget} className="control-btn" title="Expand"><ChevronUp size={16} /></button>
              ) : (
                <button onClick={minimizeWidget} className="control-btn" title="Minimize"><ChevronDown size={16} /></button>
              )}
              <button onClick={closeWidget} className="control-btn close" title="Close"><X size={16} /></button>
            </div>
          </div>
          {!isMinimized && (
            <>
              <div className="widget-body">
                <iframe src={EXTERNAL_SERVICES.intellicareWidget} title="IntellicareAI Chat" allow="microphone" className="widget-iframe" />
              </div>
              <div className="widget-footer">
                <span>Powered by My Safe Spaces</span>
                <a href="/intellicare-ai">Learn More</a>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default IntellicareWidget;
